import { Box, TextField } from "@mui/material";

export default function ProductLimitsSection({
  values = {},
  setValues = () => {},
}) {
  const safeMeta = values.metafields || {};

  const handleChange = (key, val) => {
    setValues((prev) => ({
      ...prev,
      metafields: {
        ...(prev.metafields || {}),
        [key]: val,
      },
    }));
  };

  return (
    <Box sx={{ mb: 4 }}>
      {/* Maximum Units Per Order */}
      <Box sx={{ mb: 4 }}>
        <TextField
          label="Maximum Units Per Order"
          name="custom_limit_prod"
          placeholder="Enter a number (e.g., 2)"
          type="number"
          fullWidth
          size="small"
          value={safeMeta.limit_prod || ""}
          onChange={(e) => handleChange("limit_prod", e.target.value)}
          slotProps={{
            htmlInput: { min: 0 },
          }}
          helperText="Enter the maximum number of units a customer can add to a single order. Leave blank for no limit."
        />
      </Box>

      {/* Maximum Displayed Stock Quantity */}
      <Box>
        <TextField
          label="Maximum Displayed Stock Quantity"
          name="custom_expensive_product_limit"
          placeholder="Enter a number (e.g., 10)"
          type="number"
          fullWidth
          size="small"
          value={safeMeta.expensive_product_limit || ""}
          onChange={(e) =>
            handleChange("expensive_product_limit", e.target.value)
          }
          slotProps={{
            htmlInput: { min: 0 },
          }}
          helperText="Sets the maximum number of units shown as “in stock” on the product page. Leave blank for default value (60)."
        />
      </Box>
    </Box>
  );
}